import { Reveal, ChapterLabel } from "./Reveal";
import { PROBLEM_STORIES } from "@/data";

export default function Problem() {
  return (
    <section id="why" data-testid="why-section" className="relative py-16 sm:py-24">
      <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
        <ChapterLabel number="01" label="The Problem" />
        <Reveal delay={0.1}>
          <h2
            data-testid="why-heading"
            className="mt-6 font-display text-3xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-tight text-[#FFFDF9] max-w-3xl"
          >
            The problem isn't always teaching.
            <br />
            Sometimes, it's the <span className="italic text-[#38BDF8]">visuals</span>.
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-4 max-w-md text-sm text-slate-400 leading-relaxed">
            Three people. One classroom. The same quiet struggle — not with teaching, but with
            picturing.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-10 md:grid-cols-3">
          {PROBLEM_STORIES.map((s, i) => (
            <Reveal key={s.role} delay={0.1 * i} className="group">
              <div data-testid={`problem-story-${i}`} className="cursor-default">
                <div className="overflow-hidden rounded-xl">
                  <img
                    src={s.img}
                    alt={s.role}
                    loading="lazy"
                    className="aspect-[4/3] w-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.05]"
                  />
                </div>
                <div className="mt-5 flex items-baseline gap-4">
                  <span className="font-display italic text-[#38BDF8]/80 text-sm">0{i + 1}</span>
                  <div>
                    <p className="text-[10px] tracking-[0.3em] uppercase text-slate-400">{s.role}</p>
                    <p className="mt-2 font-display text-lg leading-snug text-slate-100">
                      “{s.quote}”
                    </p>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
